import type { CreativeOverridesPayload } from "../../api/posterService";

/**
 * #1 自由创作「特别要求(选填)」→ creativeOverrides。非空(trim 后)才透传 extraConstraint。
 *
 * 2026-07-13 — 加 ratioFollowsSource:i2i 跟随原图(用户没手选比例)时置 true,ai orchestrator
 * 按参考图实测宽高定 ratio —— 前端选图时已量图回填 form.ratio,此标志是量图失败时的服务端兜底。
 * 两者都空/false 返 undefined(不发,后端 null=不改)。
 */
export function buildCreativeOverrides(
  extraConstraint?: string,
  ratioFollowsSource?: boolean
): CreativeOverridesPayload | undefined {
  const v = extraConstraint?.trim();
  if (!v && !ratioFollowsSource) return undefined;
  return {
    ...(v ? { extraConstraint: v } : {}),
    ...(ratioFollowsSource ? { ratioFollowsSource: true } : {}),
  };
}
